import React, { useState } from 'react'
import { FaSave } from "react-icons/fa";


function ResellerInfomation() {
    const [companyName, setcompanyName] = useState('Anbums Tech')
    const [EmailId, setEmailId] = useState('ashish@aadviktech.com')
    const [SupportNumber, setSupportNumber] = useState('7301020313')
    const [CopyrightInformation, setCopyrightInformation] = useState('anbums.co.in copyright@2026')
    return (
        <>
            <div>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1  '>
                    <h1 className='text-[#000] font-semibold text-[14px] dark:text-[#fff]'>Reseller Information
                    </h1>
                </div>

                <div className='w-[100%]'>
                    <div className='w-[100%] mt-2'>
                        <label className='text-[12px] font-semibold text-[#121519] dark:text-[#fff]' htmlFor="">Company Name</label>
                        <input type="text"
                            className='w-[100%] border-[1px] border-[#cfcdcd] rounded-lg outline-none mt-2 text-[12px] py-1 px-1 font-semibold text-[#535252]'
                            value={companyName}
                            onChange={(e) => setcompanyName(e.target.value)}
                        />
                    </div>
                    <div className='w-[100%] mt-2'>
                        <label className='text-[12px] font-semibold text-[#121519] dark:text-[#fff]' htmlFor="">Email Id</label>
                        <input type="text"
                            className='w-[100%] border-[1px] border-[#cfcdcd] rounded-lg outline-none mt-2 text-[12px] py-1 px-1 font-semibold text-[#535252]'
                            value={EmailId}
                            onChange={(e) => setEmailId(e.target.value)}
                        />
                    </div>
                    <div className='w-[100%] mt-2'>
                        <label className='text-[12px] font-semibold text-[#121519] dark:text-[#fff]' htmlFor="">Support Number</label>
                        <input type="text"
                            className='w-[100%] border-[1px] border-[#cfcdcd] rounded-lg outline-none mt-2 text-[12px] py-1 px-1 font-semibold text-[#535252]'
                            value={SupportNumber}
                            onChange={(e) => setSupportNumber(e.target.value)}
                        />
                    </div>
                    <div className='w-[100%] mt-2'>
                        <label className='text-[12px] font-semibold text-[#121519] dark:text-[#fff]' htmlFor="">Copyright Information</label>
                        <input type="text"
                            className='w-[100%] border-[1px] border-[#cfcdcd] rounded-lg outline-none mt-2 text-[12px] py-1 px-1 font-semibold text-[#535252]'
                            value={CopyrightInformation}
                            onChange={(e) => setCopyrightInformation(e.target.value)}
                        />
                    </div>
                    <div className='w-[100%] mt-2'>
                        <label className='text-[12px] text-[#121519] font-semibold dark:text-[#fff]' htmlFor="">Logo</label>
                        <input type="file"
                            className='w-[100%] border-[1px] border-[#cfcdcd] rounded-lg outline-none mt-2 text-[12px]  font-semibold   text-[#535252] py-2 px-2'
                           
                        />
                    </div>
                    <div className='w-[100%] flex justify-end'>
                    <span className='text-[10px] text-red-600'>Logo Size: Height 35px | Width 50-180px | Max 300KB</span>
                    </div>
                </div>

                <button className='border-[1px] border-[#3f7fca] text-[#3f7fca] hover:bg-[#3f7fca] hover:text-[#fff] flex items-center text-[12px] p-2 font-semibold rounded-lg gap-1 mt-4'><FaSave />
                    Save</button>
            </div>

        </>
    )
}

export default ResellerInfomation
